import home from './src/home.vue'
import SmartTolietManagerView from './src/SmartTolietManager/SmartTolietManagerView.vue' //智慧厕所设备列表
import SmartTolietManagerInfo from './src/SmartTolietManager/SmartTolietManagerInfo.vue' //智慧厕所设备详情

let views = {
    home,
    SmartTolietManagerView,
    SmartTolietManagerInfo
};

export default views;